/* R24 · Küchen-Finder (25.09.2026) — Kategorie-Filter fuer Kuechen-Kollektionen.
   Markup: snippets/r24-kfinder.liquid · Daten: templates/collection.kfilter.liquid (?view=kfilter)
   Vertrag: scripts/kfinder.contract.test.mjs

   Ablauf
   - Die Daten (Merkmale + fertige Karte je Produkt) kommen in Seiten zu 50 aus ?view=kfilter — mit
     DENSELBEN Parametern wie die Seite (Shopify-Filter Preis/Farbe, sort_by). Dadurch passen Zaehler und
     Reihenfolge zur sichtbaren Liste; der Finder filtert nur noch Form/Breite/Serie darueber.
   - Geladen wird im Leerlauf nach dem Seitenaufbau (fuer die Zaehler) oder sofort beim ersten Klick.
   - Zaehler je Gruppe „facettiert“: jede Gruppe zaehlt mit den Filtern der ANDEREN Gruppen. Ein Wert
     ohne Treffer verschwindet (keine Sackgasse); der gewaehlte bleibt stehen.
   - Sobald der Finder filtert, gehoert ihm das Raster: das Nachladen der Section haelt an, der Finder
     zeigt 36 Karten und darunter „Weitere anzeigen“.
   - Zustand in der Adresse (kform, kbreite, kwand, kserie) — Links lassen sich teilen; Shopify ignoriert
     diese Parameter serverseitig.
   Mobil (≤ 749 px, P1-8): Formen = eine wischbare Chip-Reihe, Breite/Front/Wand/Serie hinter „Mehr Filter (n aktiv)“,
     aktive Filter als Chips darueber; nach einer Form-Wahl scrollt die Seite sanft zum Ergebnis-Zaehler (nur wenn er
     nicht zu sehen ist, reduced-motion = ohne Animation). Der Knopf „Filter“ (Shopify-Blatt) zaehlt die Finder-Filter mit,
     das Blatt nennt sie oben als entfernbare Chips.
   Ehrlich: Merkmale nur aus Daten; ohne Breite zaehlt ein Produkt in keiner Breiten-Stufe, ohne Serie in
   keiner Serie. Nichts wird geschaetzt. */
(function (W) {
  'use strict';
  var D = W.document;
  var KP = ['kform', 'kbreite', 'kwand', 'kserie', 'kfarbe'];
  var STEP = 36;
  var FORM_NAMES = { linear: 'Küchenzeile', l_shape: 'L-Küche', u_shape: 'U-Küche', island: 'Inselküche', parallel: 'Zweizeilig', custom: 'Weitere Formen' };

  /* EINE Abrufregel (gleichlautend in allen Kopien, scripts/fetch-hardening.contract.test.mjs). */
  function r24Fetch(url, init, retry, ms){
    var ctl = typeof AbortController === 'function' ? new AbortController() : null, tm = 0, o = {}, k;
    for (k in (init || {})) o[k] = init[k];
    if (ctl){ o.signal = ctl.signal; tm = setTimeout(function(){ ctl.abort(); }, ms || 20000); }
    return fetch(url, o).then(function(r){
      return r.text().then(function(t){
        clearTimeout(tm);
        var d = null, s = r.status, wait;
        if (/^\s*[\[{]/.test(t || '')){ try { d = JSON.parse(t); } catch (e) { d = null; } }
        if (s === 429 && retry){
          wait = Math.min(4, Math.max(1, parseFloat(r.headers && r.headers.get('Retry-After')) || 1.5));
          return new Promise(function(go){ setTimeout(go, wait * 1000); }).then(function(){ return r24Fetch(url, init, false, ms); });
        }
        return { ok: r.ok, status: s, data: d, text: t || '', url: r.url || '',
          kind: r.ok ? (d ? 'ok' : 'empty') : s === 429 ? 'rate' : s >= 500 ? 'server' : 'client' };
      });
    }).then(null, function(e){
      clearTimeout(tm);
      var to = !!(e && e.name === 'AbortError');
      if (typeof console !== 'undefined') console.warn('[R24] ' + url + ': ' + (to ? 'Zeitlimit' : (e && e.message) || e));
      return { ok: false, status: 0, data: null, text: '', url: '', kind: to ? 'timeout' : 'network' };
    });
  }

  /* ---------- reine Logik (auch im Node-Test ausgefuehrt) ---------- */
  function cap(w) { w = String(w || '').toLowerCase(); return w.charAt(0).toUpperCase() + w.slice(1); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function reEsc(s) { return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }

  /* Serien-Familien = erstes Wort jeder custom.serie („Velmora - Grau“ → Velmora, „KENDRO“ → Kendro).
     Ein Produkt gehoert zu jeder Familie, die in seiner Serie ODER seinem Titel als eigenes Wort steht
     („Morvex & Kendro“ → beide; Titel „Winkelküche – Sorento – K41“ ohne Serie-Feld → Sorento, sofern
     Sorento bei einem anderen Produkt als Serie gepflegt ist). */
  function families(items, extra) {
    var F = {}, list = [];
    /* Namen aus der Einstellung „Weitere Seriennamen“: nur Kandidaten — gezeigt wird eine Serie erst, wenn
       sie woertlich in Serie oder Titel mindestens eines Produkts steht (ohne Treffer kein Eintrag). */
    String(extra || '').split(',').forEach(function (n) { n = n.trim(); if (/^[A-Za-zÄÖÜäöüß]{3,}$/.test(n)) F[cap(n)] = 1; });
    items.forEach(function (it) {
      var m = /^[\s\-–]*([A-Za-zÄÖÜäöüß]{3,})/.exec(it.s || '');
      if (m) F[cap(m[1])] = 1;
    });
    for (var k in F) list.push(k);
    list.sort(function (a, b) { return a.localeCompare(b, 'de'); });
    var res = list.map(function (n) { return { n: n, re: new RegExp('(^|[^A-Za-zÄÖÜäöüß])' + reEsc(n) + '($|[^A-Za-zÄÖÜäöüß])', 'i') }; });
    var used = {};
    items.forEach(function (it) {
      var txt = (it.s || '') + ' ' + (it.t || '');
      it.fam = res.filter(function (r) { return r.re.test(txt); }).map(function (r) { used[r.n] = 1; return r.n; });
    });
    return list.filter(function (n) { return used[n]; });
  }
  /* Frontfarbe: Grundtoene aus custom.farbe_front, der Serie und den Werten der Varianten-Option „Farbe“;
     nur wenn alle drei leer sind, aus dem Titel. Holzdekore (Eiche, Woodline, Artisan …) = „Holzoptik“. */
  var COLORS = [
    ['Weiß', /wei(ß|ss)|white|kaschmir\s*wei/i, '#f4f4f1'], ['Grau', /grau|anthrazit|platin|graphit/i, '#8a8b8c'],
    ['Beige', /beige|kaschmir|creme|sand/i, '#d8cbb3'], ['Schwarz', /schwarz|black/i, '#2a2a2a'],
    ['Grün', /gr(ü|ue)n|salbei|oliv/i, '#7d8b6a'], ['Braun', /kaffee|braun|mokka/i, '#6b4e3a'],
    ['Holzoptik', /eiche|woodline|artisan|sonoma|halifax|holz|milano|pinie|walnuss/i, '#b89778']
  ];
  function colorsOf(it) {
    var src = [it.ff || '', it.s || ''].concat(it.fo || []).join(' ');
    if (!src.trim()) src = it.t || '';
    /* „Andersen Kiefer/Pinie“ (Provence) ist ein WEISSES Landhaus-Dekor (Produktfotos) — kein Holzton. */
    src = src.replace(/andersen\s+(kiefer|pinie)/ig, 'Weiß');
    return COLORS.filter(function (c) { return c[1].test(src); }).map(function (c) { return c[0]; });
  }
  function parseRange(v) { var p = String(v).split('-'); return [parseInt(p[0], 10) || 0, parseInt(p[1], 10) || 99999]; }
  function inRange(b, v) { if (b == null) return false; var r = parseRange(v); return b >= r[0] && b <= r[1]; }
  /* skip: Name der Gruppe, die NICHT geprueft wird (fuer ihre eigenen Zaehler). */
  function match(it, st, skip) {
    if (skip !== 'f' && st.f && it.f !== st.f) return false;
    if (skip !== 'b' && st.b.length && !st.b.some(function (v) { return inRange(it.b, v); })) return false;
    if (skip !== 'w' && st.w && !(it.b != null && it.b <= st.w)) return false;
    if (skip !== 'c' && st.c && st.c.length && !st.c.some(function (n) { return it.col && it.col.indexOf(n) >= 0; })) return false;
    if (skip !== 's' && st.s.length && !st.s.some(function (n) { return it.fam && it.fam.indexOf(n) >= 0; })) return false;
    return true;
  }
  function counts(items, st, buckets, fams) {
    var c = { f: {}, fAll: 0, b: {}, s: {}, col: {}, hits: 0 };
    var seenG = {};
    items.forEach(function (it) {
      if (match(it, st, 'f')) { c.fAll++; if (it.f) c.f[it.f] = (c.f[it.f] || 0) + 1; }
      if (match(it, st, 'b')) buckets.forEach(function (v) { if (inRange(it.b, v)) c.b[v] = (c.b[v] || 0) + 1; });
      if (match(it, st, 's')) (it.fam || []).forEach(function (n) { c.s[n] = (c.s[n] || 0) + 1; });
      if (match(it, st, 'c')) (it.col || []).forEach(function (n) { c.col[n] = (c.col[n] || 0) + 1; });
      if (match(it, st) && (!it.g || !seenG[it.g])) { c.hits++; if (it.g) seenG[it.g] = 1; }
    });
    return c;
  }
  /* Farbgruppe (30.09.2026): dieselbe Kueche in mehreren Farben = eine Karte (die erste Treffer-Farbe, im Farb-Filter also
     die passende); die anderen Farben sind Punkte auf der Karte (snippets/r24-farbgruppe). Ohne Schluessel bleibt alles. */
  function oneColor(list) {
    var seen = {};
    return list.filter(function (it) { if (!it.g) return true; if (seen[it.g]) return false; seen[it.g] = 1; return true; });
  }
  function active(st) { return !!(st.f || st.b.length || st.w || st.s.length || (st.c && st.c.length)); }
  function readState(search) {
    var q = new URLSearchParams(search || '');
    var list = function (k) { return (q.get(k) || '').split(',').map(function (x) { return x.trim(); }).filter(Boolean); };
    var w = parseInt(q.get('kwand'), 10);
    return { f: (q.get('kform') || '').trim(), b: list('kbreite'), w: w >= 100 && w <= 900 ? w : 0, s: list('kserie'), c: list('kfarbe') };
  }
  function writeState(href, st) {
    var u = new URL(href, 'https://x.invalid');
    KP.forEach(function (k) { u.searchParams.delete(k); });
    if (st.f) u.searchParams.set('kform', st.f);
    if (st.b.length) u.searchParams.set('kbreite', st.b.join(','));
    if (st.w) u.searchParams.set('kwand', String(st.w));
    if (st.s.length) u.searchParams.set('kserie', st.s.join(','));
    if (st.c && st.c.length) u.searchParams.set('kfarbe', st.c.join(','));
    return u.pathname + (u.search || '') + (u.hash || '');
  }
  /* Datenadresse: dieselben Parameter wie die Seite, ohne Finder-/Seitenparameter. */
  function dataKey(search) {
    var q = new URLSearchParams(search || '');
    KP.concat(['page', 'view', 'section_id', 'ansicht']).forEach(function (k) { q.delete(k); });
    q.sort && q.sort();
    return q.toString();
  }

  /* Mobil = dieselbe Grenze wie das CSS im Snippet (max-width:749px). */
  function isMobile() { return !!(W.matchMedia && W.matchMedia('(max-width: 749px)').matches); }
  function calm() { return !!(W.matchMedia && W.matchMedia('(prefers-reduced-motion: reduce)').matches); }
  /* Zahl der Finder-Filter hinter „Mehr Filter“ (die Form steht sichtbar in der Chip-Reihe). */
  function moreCount(st) { return st.b.length + (st.w ? 1 : 0) + ((st.c && st.c.length) || 0) + st.s.length; }
  function activeCount(st) { return (st.f ? 1 : 0) + moreCount(st); }
  /* Serie-Liste: Kopfzeile „Serie“ steht IMMER als erste Zeile; ohne Treffer ein Satz statt eines leeren Kastens
     (vorher: nach einem Formwechsel ohne Serie-Treffer bzw. vor dem Laden ein leeres weisses Feld unter „Serie“). */
  function seriesPop(fams, cs, sel, ready) {
    var rows = ready ? fams.filter(function (n) { return cs[n] || sel.indexOf(n) >= 0; }) : [];
    var h = '<p class="r24kf-opt__h" aria-hidden="true">Serie wählen · mehrere möglich</p>';
    if (!ready) return h + '<p class="r24kf-opt__none">Serien werden geladen …</p>';
    if (!rows.length) return h + '<p class="r24kf-opt__none">Für diese Auswahl ist keine Serie hinterlegt.</p>';
    return h + rows.map(function (n) {
      var on = sel.indexOf(n) >= 0;
      return '<label class="r24kf-opt"><input type="checkbox" id="r24kf-s-' + esc(String(n).toLowerCase().replace(/[^a-z0-9]+/g, '-')) + '" data-kf-s="' + esc(n) + '"' + (on ? ' checked' : '') + '><span>' + esc(n) + '</span><span class="r24kf-opt__c">' + (cs[n] || 0) + '</span></label>';
    }).join('') + (sel.length ? '<button type="button" class="r24kf-opt__clr" data-kf-sclr>Serie zurücksetzen</button>' : '');
  }

  /* ---------- Oberflaeche ---------- */
  function mount(sec, hooks) {
    hooks = hooks || {};
    var box = sec.querySelector('[data-r24kf]');
    if (!box || box.dataset.kfBound) return null;
    box.dataset.kfBound = '1';
    box.classList.add('is-js');
    var showBtn = box.querySelector('[data-kf-show]'); if (showBtn) showBtn.hidden = false;
    var src = box.getAttribute('data-src');
    var cache = {};
    var st = readState(W.location.search);
    var own = false, lim = STEP, items = null, fams = [], loading = null, lastKey = null, failed = false;
    var buckets = [].map.call(box.querySelectorAll('[data-kf-b]'), function (a) { return a.getAttribute('data-kf-b'); });

    function q(sel) { return box.querySelector(sel); }
    /* Mit Skript sind Formen/Breiten Umschalter, keine Seitenwechsel: Rolle „button“ (aria-pressed gilt dann)
       und Leertaste wie bei einem Knopf. Ohne Skript bleiben es Links auf die Kollektionen. */
    [].forEach.call(box.querySelectorAll('[data-kf-f],[data-kf-b]'), function (a) { a.setAttribute('role', 'button'); });
    box.addEventListener('keydown', function (e) {
      var a = (e.key === ' ' || e.key === 'Spacebar') && e.target.closest && e.target.closest('[data-kf-f],[data-kf-b]');
      if (a) { e.preventDefault(); a.click(); }
    });
    function note(msg) { var n = q('[data-kf-note]'); if (!n) return; n.textContent = msg || ''; n.hidden = !msg; }

    function load(key) {
      if (cache[key]) return cache[key];
      var base = src + '?' + (key ? key + '&' : '') + 'view=kfilter';
      /* KEIN „Accept: application/json“ — damit liefert Shopify statt der Ansicht das eigene Kollektions-JSON. */
      var init = { credentials: 'same-origin' };
      function page(n) {
        return r24Fetch(base + '&page=' + n, init, false).then(function (r) {
          if (!r.ok || !r.data || !r.data.items) { var e = new Error('Daten'); e.kind = r.kind; throw e; }
          return r.data;
        });
      }
      var p = page(1).then(function (d1) {
        var rest = [], all = d1.items.slice();
        for (var i = 2; i <= Math.min(d1.pages || 1, 20); i++) rest.push(i);
        /* Hoechstens zwei Anfragen gleichzeitig — schont die Storefront (429). */
        function next() {
          if (!rest.length) return Promise.resolve();
          var a = rest.splice(0, 2);
          return Promise.all(a.map(page)).then(function (ds) { ds.forEach(function (d) { all = all.concat(d.items || []); }); return next(); });
        }
        return next().then(function () { return all; });
      });
      cache[key] = p;
      p.then(null, function () { delete cache[key]; });
      return p;
    }

    function ensure() {
      var key = dataKey(W.location.search);
      if (items && key === lastKey) return Promise.resolve(items);
      if (loading && loading.key === key) return loading.p;
      box.classList.add('is-busy');
      var p = load(key).then(function (list) {
        items = list; lastKey = key; failed = false;
        fams = families(items, box.getAttribute('data-series'));
        items.forEach(function (it) { it.col = colorsOf(it); });
        box.classList.remove('is-busy'); box.classList.add('is-ready');
        note('');
        return items;
      }, function (e) {
        box.classList.remove('is-busy'); failed = true;
        note(e && e.kind === 'rate' ? 'Gerade sind viele Anfragen unterwegs — bitte gleich noch einmal wählen.' : 'Der Küchen-Finder konnte nicht geladen werden. Bitte versuchen Sie es erneut.');
        throw e;
      });
      loading = { key: key, p: p };
      p.then(function () { loading = null; }, function () { loading = null; });
      return p;
    }

    function setPressed(el, on) { el.classList.toggle('is-on', on); el.setAttribute('aria-pressed', on ? 'true' : 'false'); }

    function paintBar() {
      if (!items) return;
      var c = counts(items, st, buckets, fams);
      var formsSeen = {}, nForms = 0;
      items.forEach(function (it) { if (it.f && !formsSeen[it.f]) { formsSeen[it.f] = 1; nForms++; } });
      var fg = q('[data-kf-group="f"]');
      if (fg) fg.hidden = nForms < 2 && !st.f;
      [].forEach.call(box.querySelectorAll('[data-kf-f]'), function (a) {
        var v = a.getAttribute('data-kf-f'), n = v ? (c.f[v] || 0) : c.fAll;
        setPressed(a, v === st.f);
        a.hidden = !!v && !n && v !== st.f;
        var ce = a.querySelector('[data-kf-c]'); if (ce) ce.textContent = String(n);
        a.setAttribute('aria-label', (v ? FORM_NAMES[v] || v : 'Alle Formen') + ', ' + n + ' ' + (n === 1 ? 'Produkt' : 'Produkte'));
      });
      var bSeen = 0;
      [].forEach.call(box.querySelectorAll('[data-kf-b]'), function (a) {
        var v = a.getAttribute('data-kf-b'), n = c.b[v] || 0, on = st.b.indexOf(v) >= 0;
        setPressed(a, on);
        a.hidden = !n && !on;
        if (n || on) bSeen++;
        var ce = a.querySelector('[data-kf-c]'); if (ce) ce.textContent = String(n);
      });
      var withB = items.some(function (it) { return it.b != null; });
      var seg = q('[data-kf-group="b"]'); if (seg) seg.hidden = bSeen < 2 && !st.b.length;
      var wb = q('[data-kf-wallbox]'); if (wb) wb.hidden = !withB;
      var wi = q('[data-kf-wall]'); if (wi && D.activeElement !== wi) wi.value = st.w ? String(st.w) : '';
      var dd = q('[data-kf-dd]'), pop = q('[data-kf-pop]');
      if (dd) dd.hidden = fams.length < 2;
      /* Nur die Liste wird neu gebaut — die Beschriftung „Serie“ im Knopf (.r24kf-dd__l) nie. */
      if (pop) pop.innerHTML = seriesPop(fams, c.s, st.s, true);
      var cg = q('[data-kf-group="c"]'), cl = q('[data-kf-colors]');
      if (cl) {
        var shown = COLORS.filter(function (x) { return c.col[x[0]] || st.c.indexOf(x[0]) >= 0; });
        cl.innerHTML = shown.map(function (x) {
          var on = st.c.indexOf(x[0]) >= 0;
          return '<button type="button" class="r24kf-chip' + (on ? ' is-on' : '') + '" data-kf-c-col="' + x[0] + '" aria-pressed="' + on + '"><span class="r24kf-dot" style="background:' + x[2] + '"></span>' + x[0] + '<span class="r24kf-chip__c">' + (c.col[x[0]] || 0) + '</span></button>';
        }).join('');
        if (cg) cg.hidden = shown.length < 2 && !st.c.length;
      }
      var sn = q('[data-kf-sn]'); if (sn) { sn.hidden = !st.s.length; sn.textContent = String(st.s.length); }
      var sb = q('[data-kf-show]'); if (sb) sb.textContent = c.hits + ' ' + (c.hits === 1 ? 'Ergebnis' : 'Ergebnisse') + ' anzeigen';
      var ddb = q('[data-kf-ddbtn]'); if (ddb) ddb.classList.toggle('is-on', st.s.length > 0);
      paintActive();
      return c;
    }

    function pills() {
      var out = [];
      if (st.f) out.push({ k: 'f', v: st.f, l: FORM_NAMES[st.f] || st.f });
      st.b.forEach(function (v) { var a = box.querySelector('[data-kf-b="' + v + '"]'); out.push({ k: 'b', v: v, l: a ? a.firstChild.textContent.trim() : v }); });
      if (st.w) out.push({ k: 'w', v: String(st.w), l: 'passt bis ' + st.w + ' cm' });
      st.s.forEach(function (n) { out.push({ k: 's', v: n, l: 'Serie ' + n }); });
      st.c.forEach(function (n) { out.push({ k: 'c', v: n, l: 'Front ' + n }); });
      return out;
    }
    function pillHTML(ps) {
      return ps.map(function (p) {
        return '<button type="button" class="r24kf-pill" data-kf-rm="' + p.k + '" data-v="' + esc(p.v) + '" aria-label="Filter ' + esc(p.l) + ' entfernen">' + esc(p.l) +
          '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button>';
      }).join('');
    }
    function paintActive() {
      var a = q('[data-kf-active]'); if (!a) return;
      var ps = pills();
      a.hidden = !ps.length;
      a.innerHTML = pillHTML(ps) + (ps.length > 1 ? '<button type="button" class="r24kf-reset" data-kf-reset>Alle zurücksetzen</button>' : '');
      paintMore();
      paintSheet(ps);
    }
    /* „Mehr Filter (n aktiv)“ — n = Breite/Wand/Front/Serie (die Form steht sichtbar in der Chip-Reihe). */
    function paintMore() {
      var b = q('[data-kf-more-btn]'), l = q('[data-kf-more-l]'), n = moreCount(st);
      if (!b || !l) return;
      l.textContent = n ? 'Mehr Filter (' + n + ' aktiv)' : 'Mehr Filter';
      b.classList.toggle('is-on', n > 0);
    }
    function setMore(open) {
      box.classList.toggle('is-more', open);
      var b = q('[data-kf-more-btn]'); if (b) b.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    /* Shopify-Filterblatt: Der Knopf „Filter“ zaehlt die Finder-Filter mit, und das Blatt nennt sie oben als
       entfernbare Chips — sonst stuende „Filter (2)“ ueber einem Blatt, das nur den Preis zeigt.
       Beide Stellen tauscht die Section nach jedem Shopify-Filterwechsel aus → nach jedem Neuzeichnen erneut. */
    function paintSheet(ps) {
      var n = activeCount(st);
      var fb = sec.querySelector('[data-r24-filter-open]');
      if (fb) {
        var own = fb.querySelector('.r24col-filterbtn__n:not([data-kf-n])');
        var base = own ? (parseInt(own.textContent, 10) || 0) : 0;
        var mine = fb.querySelector('[data-kf-n]');
        if (!n) { if (mine) mine.remove(); if (own) own.style.display = ''; fb.removeAttribute('aria-label'); }
        else {
          if (!mine) { mine = D.createElement('span'); mine.className = 'r24col-filterbtn__n'; mine.setAttribute('data-kf-n', ''); fb.appendChild(mine); }
          mine.textContent = String(base + n);
          if (own) own.style.display = 'none'; /* [hidden] verliert gegen die display-Regel des Zaehlers */
          fb.setAttribute('aria-label', 'Filter, ' + (base + n) + ' aktiv (davon ' + n + ' im Küchen-Finder)');
        }
      }
      var side = sec.querySelector('#r24col-filters');
      if (!side) return;
      var sh = side.querySelector('[data-kf-sheet]');
      if (!ps.length) { if (sh) sh.remove(); return; }
      if (!sh) {
        sh = D.createElement('div'); sh.className = 'r24kf-sheet'; sh.setAttribute('data-kf-sheet', '');
        var anchor = side.querySelector('.r24col-fgroups');
        if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(sh, anchor); else side.appendChild(sh);
      }
      sh.innerHTML = '<p class="r24kf-sheet__t">Küchen-Finder</p><div class="r24kf-sheet__l">' + pillHTML(ps) + '</div>' +
        '<button type="button" class="r24kf-sheet__go" data-kf-sheetgo>Form, Breite, Front und Serie ändern</button>';
    }

    function without(k, v) {
      var s2 = { f: st.f, b: st.b.slice(), w: st.w, s: st.s.slice(), c: st.c.slice() };
      if (k === 'f') s2.f = ''; else if (k === 'w') s2.w = 0;
      else s2[k] = s2[k].filter(function (x) { return x !== v; });
      return s2;
    }

    function results() {
      var grid = sec.querySelector('#r24col-grid'), res = sec.querySelector('#r24col-results');
      if (!res) return;
      var hits = oneColor(items.filter(function (it) { return match(it, st); }));
      if (hooks.stopPager) hooks.stopPager();
      own = true;
      var bar = res.querySelector('[data-r24-morebar]'); if (bar) bar.hidden = true;
      var empty = res.querySelector('.r24col-empty'); if (empty && hits.length) empty.hidden = true;
      if (!grid) { grid = D.createElement('div'); grid.className = 'r24col-grid'; grid.id = 'r24col-grid'; res.insertBefore(grid, res.firstChild); }
      var old = res.querySelector('[data-kf-more]'); if (old) old.remove();
      var old2 = res.querySelector('[data-kf-empty]'); if (old2) old2.remove();
      grid.innerHTML = hits.slice(0, lim).map(function (it) { return it.c; }).join('');
      grid.hidden = !hits.length;
      if (!hits.length) {
        var tips = pills().map(function (p) {
          var s2 = without(p.k, p.v), n = items.filter(function (it) { return match(it, s2); }).length;
          return n ? '<button type="button" class="r24kf-chip" data-kf-rm="' + p.k + '" data-v="' + esc(p.v) + '">Ohne „' + esc(p.l) + '“ <span class="r24kf-chip__c">' + n + '</span></button>' : '';
        }).join('');
        var e = D.createElement('div'); e.className = 'r24kf-empty'; e.setAttribute('data-kf-empty', '');
        e.innerHTML = '<p class="r24kf-empty__t">Keine Küche passt zu dieser Auswahl.</p>' +
          (tips ? '<p class="r24kf-empty__s">So finden Sie wieder Treffer:</p><div class="r24kf-empty__tips">' + tips + '</div>' : '') +
          '<button type="button" class="r24kf-reset" data-kf-reset>Küchen-Finder zurücksetzen</button>';
        res.appendChild(e);
      } else if (hits.length > lim) {
        var m = D.createElement('div'); m.className = 'r24kf-more'; m.setAttribute('data-kf-more', '');
        m.innerHTML = '<div class="r24col-more__txt"><strong>' + Math.min(lim, hits.length) + '</strong> von <strong>' + hits.length + '</strong> angezeigt</div>' +
          '<div class="r24col-more__bar"><span style="width:' + (Math.min(lim, hits.length) / hits.length * 100) + '%"></span></div>' +
          '<button type="button" class="r24col-more__btn" data-kf-morebtn>Weitere ' + Math.min(STEP, hits.length - lim) + ' anzeigen</button>';
        res.appendChild(m);
      }
      var cnt = sec.querySelector('[data-r24col-count]');
      if (cnt) cnt.innerHTML = '<strong>' + hits.length + '</strong> ' + (hits.length === 1 ? 'Produkt' : 'Produkte');
      var live = sec.querySelector('[data-r24col-live]');
      if (live) live.textContent = hits.length + ' ' + (hits.length === 1 ? 'Produkt' : 'Produkte') + ' gefunden';
      D.dispatchEvent(new CustomEvent('r24col:updated'));
      if (hooks.onRender) hooks.onRender(hits.length);
    }

    /* Warten auf Daten, waehrend der Finder filtert: die (noch ungefilterte) Shopify-Liste abdunkeln und keine
       falsche Zahl zeigen — sonst blitzt nach Sortier-/Filterwechsel kurz „220 Produkte“ auf. */
    function wait(on) {
      var res = sec.querySelector('#r24col-results'); if (res) { res.classList.toggle('r24kf-wait', on); res.setAttribute('aria-busy', on ? 'true' : 'false'); }
      var cnt = sec.querySelector('[data-r24col-count]'); if (on && cnt) cnt.innerHTML = '<strong>…</strong> Produkte';
    }

    function syncUrl() {
      try { W.history.replaceState(W.history.state, '', writeState(W.location.href, st)); } catch (e) {}
    }

    function apply(opts) {
      opts = opts || {};
      syncUrl();
      paintActive();
      var needs = active(st) || own;
      if (needs && !(items && lastKey === dataKey(W.location.search))) wait(true);
      return ensure().then(function () {
        paintBar();
        if (needs) results();
        wait(false);
        if (opts.scroll && isMobile()) toCount();
        else if (opts.scroll) {
          var t = sec.querySelector('#r24col-toolbar') || box;
          var r = t.getBoundingClientRect();
          if (r.top < 0 || r.top > W.innerHeight * 0.7) W.scrollTo({ top: box.getBoundingClientRect().top + W.pageYOffset - 80, behavior: 'smooth' });
        }
      }, function () { wait(false); });
    }

    /* Mobil: sanft zum Ergebnis-Zaehler („43 Produkte“) — nur wenn er nicht ohnehin zu sehen ist.
       Oben verdeckt ggf. der klebende Kopf; ohne Bewegung bei „weniger Bewegung“. */
    function topCover() {
      var h = D.querySelector('.r24hd-sticky'); if (!h) return 0;
      var r = h.getBoundingClientRect(), cs = W.getComputedStyle(h);
      return (cs.position === 'fixed' || cs.position === 'sticky') && r.bottom > 0 && r.top <= 1 ? r.bottom : 0;
    }
    function toCount() {
      if (sec.querySelector('#r24col-filters.is-open')) return; /* offenes Filterblatt: Seite bleibt stehen */
      var t = sec.querySelector('[data-r24col-count]') || sec.querySelector('#r24col-toolbar'); if (!t) return;
      var r = t.getBoundingClientRect(), off = topCover() + 12;
      if (r.top >= off && r.bottom <= W.innerHeight - 8) return;
      W.scrollTo({ top: Math.max(0, r.top + W.pageYOffset - off), behavior: calm() ? 'auto' : 'smooth' });
    }
    /* how: nach der Wahl zur Liste? Mobil scrollen Form-Chips und Entfernen; im offenen „Mehr Filter“ waehlt man oft
       mehreres — dort bleibt die Seite stehen, und „Ergebnisse anzeigen“ fuehrt zur Liste. */
    function change(fn, how) { fn(); lim = STEP; apply({ scroll: how === undefined ? true : how }); }

    box.addEventListener('click', function (e) {
      var a = e.target.closest('[data-kf-f]');
      if (a) { e.preventDefault(); var v = a.getAttribute('data-kf-f'); change(function () { st.f = st.f === v ? '' : v; }); reveal(a); return; }
      var b = e.target.closest('[data-kf-b]');
      if (b) { e.preventDefault(); var bv = b.getAttribute('data-kf-b'); change(function () { var i = st.b.indexOf(bv); if (i >= 0) st.b.splice(i, 1); else st.b.push(bv); }, panelScroll()); return; }
      if (e.target.closest('[data-kf-more-btn]')) { var op = !box.classList.contains('is-more'); setMore(op); if (op) ensure().then(paintBar, function () {}); return; }
      if (e.target.closest('[data-kf-show]')) { setMore(false); toCountAfterPaint(); return; }
      var ddb = e.target.closest('[data-kf-ddbtn]');
      if (ddb) {
        var pop = q('[data-kf-pop]'), open = pop.hidden; pop.hidden = !open; ddb.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) { if (!items) pop.innerHTML = seriesPop(fams, {}, st.s, false); ensure().then(paintBar, function () { pop.hidden = true; ddb.setAttribute('aria-expanded', 'false'); }); }
        return;
      }
      var cc = e.target.closest('[data-kf-c-col]');
      if (cc) { var cv = cc.getAttribute('data-kf-c-col'); change(function () { var i = st.c.indexOf(cv); if (i >= 0) st.c.splice(i, 1); else st.c.push(cv); }, panelScroll()); return; }
      if (e.target.closest('[data-kf-sclr]')) { change(function () { st.s = []; }, panelScroll()); return; }
    });
    /* Mobil ist die Formen-Reihe wischbar: die gewaehlte Form ganz in den Blick schieben (nur waagrecht). */
    function reveal(el) {
      var row = el.parentNode; if (!isMobile() || !row || row.scrollWidth <= row.clientWidth) return;
      var r = el.getBoundingClientRect(), rr = row.getBoundingClientRect();
      if (r.left >= rr.left + 8 && r.right <= rr.right - 8) return;
      var x = row.scrollLeft + (r.left - rr.left) - 16;
      if (row.scrollTo) row.scrollTo({ left: Math.max(0, x), behavior: calm() ? 'auto' : 'smooth' }); else row.scrollLeft = x;
    }
    /* Filter im aufgeklappten „Mehr Filter“ (mobil): kein Sprung weg vom Panel. Desktop: wie bisher. */
    function panelScroll() { return !isMobile(); }
    function toCountAfterPaint() { if (W.requestAnimationFrame) W.requestAnimationFrame(toCount); else toCount(); }
    box.addEventListener('change', function (e) {
      var c = e.target.closest('[data-kf-s]');
      if (c) { var n = c.getAttribute('data-kf-s'); change(function () { st.s = st.s.filter(function (x) { return x !== n; }); if (c.checked) st.s.push(n); }, panelScroll()); }
    });
    var wt = 0;
    box.addEventListener('input', function (e) {
      if (!e.target.closest('[data-kf-wall]')) return;
      clearTimeout(wt);
      var v = parseInt(e.target.value, 10);
      wt = setTimeout(function () { change(function () { st.w = v >= 100 && v <= 900 ? v : 0; }, panelScroll()); }, 450);
    });
    /* Entfernen/Zuruecksetzen/Weitere — auch in der Ergebnisliste (Leerzustand). */
    sec.addEventListener('click', function (e) {
      var rm = e.target.closest('[data-kf-rm]');
      if (rm) { var k = rm.getAttribute('data-kf-rm'), v = rm.getAttribute('data-v'); change(function () { var s2 = without(k, v); st.f = s2.f; st.b = s2.b; st.w = s2.w; st.s = s2.s; st.c = s2.c; }); return; }
      if (e.target.closest('[data-kf-reset]')) { change(function () { st = { f: '', b: [], w: 0, s: [], c: [] }; }); return; }
      if (e.target.closest('[data-kf-sheetgo]')) {
        var cl = sec.querySelector('#r24col-filters [data-r24-filter-close]'); if (cl) cl.click();
        if (moreCount(st)) setMore(true);
        W.scrollTo({ top: Math.max(0, box.getBoundingClientRect().top + W.pageYOffset - topCover() - 8), behavior: calm() ? 'auto' : 'smooth' });
        return;
      }
      if (e.target.closest('[data-kf-morebtn]')) {
        var first = lim; lim += STEP; results();
        var g = sec.querySelector('#r24col-grid'), c = g && g.children[first];
        var l = c && (c.querySelector('a[href]:not([tabindex="-1"])') || c.querySelector('a[href]'));
        if (l) try { l.focus({ preventScroll: true }); } catch (x) {}
      }
    });
    D.addEventListener('click', function (e) {
      var dd = q('[data-kf-dd]'), pop = q('[data-kf-pop]');
      if (!pop || pop.hidden || (dd && dd.contains(e.target))) return;
      pop.hidden = true; var bt = q('[data-kf-ddbtn]'); if (bt) bt.setAttribute('aria-expanded', 'false');
    });
    D.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var pop = q('[data-kf-pop]'); if (!pop || pop.hidden) return;
      pop.hidden = true; var bt = q('[data-kf-ddbtn]'); if (bt) { bt.setAttribute('aria-expanded', 'false'); bt.focus(); }
    });

    /* Start: mit Finder-Parametern in der Adresse sofort, sonst im Leerlauf (nur fuer die Zaehler). */
    if (active(st)) apply();
    else {
      var idle = W.requestIdleCallback || function (f) { return setTimeout(f, 1200); };
      idle(function () { ensure().then(paintBar, function () { note(''); }); }, { timeout: 4000 });
    }

    return {
      /* Nach einem Shopify-Filter-/Sortierwechsel (neues Raster): Finder-Zustand wieder anwenden.
         Traegt die Adresse Finder-Parameter (Zurueck/Vor), gelten die; sonst der bisherige Zustand. */
      refresh: function () {
        var fromUrl = readState(W.location.search);
        if (active(fromUrl)) st = fromUrl;
        own = false; lim = STEP;
        if (active(st)) apply(); else { syncUrl(); ensure().then(paintBar, function () {}); }
      },
      owns: function () { return own; },
      state: function () { return st; }
    };
  }

  W.R24KF = { mount: mount, _t: { oneColor: oneColor, colorsOf: colorsOf, families: families, match: match, counts: counts, readState: readState, writeState: writeState, dataKey: dataKey, inRange: inRange, active: active, moreCount: moreCount, activeCount: activeCount, seriesPop: seriesPop } };
  var qq = W.R24KFQ;
  if (qq && qq.length) { for (var i = 0; i < qq.length; i++) { try { qq[i](W.R24KF); } catch (e) { console.warn('[R24] Küchen-Finder', e); } } }
  W.R24KFQ = { push: function (fn) { try { fn(W.R24KF); } catch (e) { console.warn('[R24] Küchen-Finder', e); } } };
})(typeof window !== 'undefined' ? window : this);
